import React from "react";

export default function NoDataContent({
  buttonOnClick,
  useButton,
  titleText,
  paragraphText,
  buttonText,
  useClickCallBack,
  callBackFunction,
  btnDisabled= false,
}) {
  return (
    <div className="no-data-content">
      <div>
        <div className="text-center">
          <h2>{titleText}</h2>
          <p className="text-muted">{paragraphText}</p>
          {useButton && (
            <button
              disabled={btnDisabled}
              className="btn btn-success"
              onClick={() =>
                useClickCallBack ? callBackFunction() : buttonOnClick(true)
              }
            >
              <i className="ri-add-line align-bottom me-1"></i>
              {buttonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
